import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import type { Sentiment } from '../model/contracts'

interface SentimentBadgeProps {
  sentiment: Sentiment
  className?: string
}

const STYLES: Record<Sentiment, string> = {
  positive:
    'border-sentiment-positive-border bg-sentiment-positive-surface text-sentiment-positive',
  negative:
    'border-sentiment-negative-border bg-sentiment-negative-surface text-sentiment-negative',
  neutral: 'border-border bg-muted/40 text-muted-foreground',
}

export function SentimentBadge({ sentiment, className }: SentimentBadgeProps) {
  const { t } = useTranslation('feed')
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-xs font-medium',
        STYLES[sentiment],
        className,
      )}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" aria-hidden />
      {t(`sentimentBadge.${sentiment}`)}
    </span>
  )
}
